export const bringToFront = (entities, entityId) => {
    if (!entityId) return entities;
    const maxZ = Math.max(0, ...entities.map(e => e.zIndex || 0));
    return entities.map(e => 
        e.id === entityId ? { ...e, zIndex: maxZ + 1 } : e
    );
};

export const sendToBack = (entities, entityId) => {
    if (!entityId) return entities;
    const minZ = Math.min(0, ...entities.map(e => e.zIndex || 0));
    return entities.map(e => 
        e.id === entityId ? { ...e, zIndex: minZ - 1 } : e
    );
};
